import { memo } from 'react';
import { useAddLiquidityState } from '@/components/AddLiquidity/AddLiquidityProvider';
import { USDCRewardsBanner } from '@/components/common/USDCRewardsBanner';
import { messages } from '@/messages';

/**
 * AddLiquidityUSDCRewardsBanner - USDC rewards banner for the Add Liquidity flow
 *
 * This component shows USDC rewards promotional content when users are adding
 * liquidity to pools that contain USDC. It automatically checks if the selected
 * token pair includes USDC and only renders the banner if so.
 *
 * The banner content varies based on user eligibility (retail vs institutional)
 * and is handled by the underlying USDCRewardsBanner component.
 */
export const AddLiquidityUSDCRewardsBanner = memo(function AddLiquidityUSDCRewardsBanner() {
  const { positionTokens } = useAddLiquidityState();

  // Only show banner for pools that contain USDC
  const isUSDCTokenPair = positionTokens.some((token) => token.symbol === 'USDC');

  if (!isUSDCTokenPair) {
    return null;
  }

  return (
    <USDCRewardsBanner
      title={{
        retail: messages['usdcRewards.addLiquidity.retail.banner.title'],
        insto: messages['usdcRewards.addLiquidity.institutional.banner.title'],
      }}
      message={{
        retail: messages['usdcRewards.addLiquidity.retail.banner.message'],
        insto: messages['usdcRewards.addLiquidity.institutional.banner.message'],
      }}
      testID="usdc-rewards-banner"
      color="green"
    />
  );
});
